import { Box, Paper, Group, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconGift, IconPercentage } from '@tabler/icons-react';
import { useTranslation } from '../../context/TranslationContext';
import './AvailableOffers.css';

const OFFER_ICONS = {
  min_order_discount: IconPercentage,
  buy_x_pay_y: IconGift,
  free_nth_order: IconGift,
};

export default function AvailableOffers({ offers }) {
  const { t } = useTranslation();

  if (!Array.isArray(offers) || offers.length === 0) return null;

  return (
    <Paper
      withBorder
      p="lg"
      radius="lg"
      shadow="xs"
      mb="md"
      className="available-offers"
      role="status"
      aria-live="polite"
    >
      <Stack gap="sm">
        <Box>
          <Title order={3} size="md" fw={800}>
            {t('cartAvailableOffers', 'Available offers')}
          </Title>
          <Text size="sm" c="dimmed">
            {t('cartAvailableOffersSubtitle', 'Unlock these offers with your order')}
          </Text>
        </Box>

        <Stack gap="xs">
          {offers.map((offer) => {
            const Icon = OFFER_ICONS[offer.rule_type] || IconGift;
            return (
              <Group key={offer.id} gap="sm" wrap="nowrap" align="flex-start">
                <ThemeIcon variant="light" color="teal" radius="xl" size="lg" aria-hidden="true">
                  <Icon size={16} />
                </ThemeIcon>
                <Stack gap={0} style={{ minWidth: 0 }}>
                  <Text size="sm" fw={600}>
                    {offer.title}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {offer.hint}
                  </Text>
                </Stack>
              </Group>
            );
          })}
        </Stack>
      </Stack>
    </Paper>
  );
}
